export enum WorkflowStatus {
  WAITING = "waiting",
}

export enum InvalidDate {
  DEFAULT = "1900-01-01T00:00:00"
}